import React, { type KeyboardEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibField } from '@chewy/kib-fields-new-react'
import { KibSendIcon } from '@chewy/kib-icons-react'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './ChatInput.module.scss'

export interface ChatInputProps {
  disabled?: boolean
  onSendMessage: (message: string) => void
  placeholder?: string
}

const ChatInput: React.FC<ChatInputProps> = ({
  onSendMessage,
  disabled = false,
  placeholder = '',
}) => {
  const [message, setMessage] = useState('')
  const { t } = useTranslation('Agent')

  const handleSend = () => {
    if (message.trim() && !disabled) {
      onSendMessage(message.trim())
      setMessage('')
    }
  }

  const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      handleSend()
    }
  }

  return (
    <div className={styles.inputContainer}>
      <div className={styles.inputWrapper}>
        <div className={styles.messageInput}>
          <KibField
            disabled={disabled}
            label=""
            placeholder={placeholder}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
          />
        </div>
        <KibButtonNew
          iconOnly
          aria-label={t('Agent:SEND_MESSAGE')}
          disabled={disabled || !message.trim()}
          icon={<KibSendIcon />}
          onClick={handleSend}
        />
      </div>
    </div>
  )
}

export default ChatInput
